export const enum FormPropertyReportStatechartStateEnum {
  /**
   * Idle state
   */
  idle = 'idle',

  /**
   * Validating user input
   */
  validating = 'validating',

  /**
   * Executing google captcha
   */
  executingCaptcha = 'executingCaptcha',

  /**
   * Checking if report was already sent
   */
  checkingIfWasAlreadySent = 'checkingIfWasAlreadySent',

  /**
   * Uploading report attachment
   */
  uploadingAttachment = 'uploadingAttachment',

  /**
   * Submitting report
   */
  submitting = 'submitting',

  /**
   * Checking if report has attachment
   */
  checkingIfHasAttachment = 'checkingIfHasAttachment',

  /**
   * Report was sent
   */
  sent = 'sent',

  updateUser = 'updateUser',
}
